export default __webpack_public_path__ + "static/media/fiercerecovery.8bce5f3c.png";